<template>
  <v-snackbar
    v-if="getSnackbarMessage.data != null"
    :color="getSnackbarMessage.data.color"
    @input="onClose"
    :value="getSnackbarMessage.isActive"
    :timeout="4000"
    multiLine
  >
    <div class="body-1">
      {{ getSnackbarMessage.data.message }}
    </div>
    <template v-slot:action="{attrs}">
      <v-btn dark text v-bind="attrs" @click="onClose()">Close</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  computed: {
    getSnackbarMessage() {
      return this.$store.getters.snackbar
    },
  },
  methods: {
    onClose() {
      this.$store.dispatch('snackbarAction', this.getSnackbarMessage.isActive)
    },
  },
}
</script>
